import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Box, InputAdornment, CircularProgress, Alert } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import EmailIcon from '@mui/icons-material/Email';
import LoginIcon from '@mui/icons-material/Login';
import { login } from '../store/user.actions';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [credentials, setCredentials] = useState({ correo: '', password_hash: '' });
  const [loading, setLoading] = useState(false);
  const [showForceCleanCache, setForceCleanCache] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });

    if (value === "reset") {
      setForceCleanCache(true);
    }
  };

  const clearCacheData = () => {
    if (showForceCleanCache) {
      alert('Actualizando a la última versión...');
    }

    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!credentials.correo || !credentials.password_hash) {
      setError('Verifique los datos proporcionados.');
      setLoading(false);
      return;
    }

    try {
      clearCacheData();

      const validarUsuario = await login(credentials); // Esperamos a que la promesa se resuelva aquí
      if (validarUsuario && validarUsuario.success === true) {
        navigate(`/tablero`);
      } else {
        setError('El correo o contraseña son incorrectos.');
      }
    } catch (err) {
      setError('Error al conectar con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        backgroundImage: 'url(/background_login.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Container maxWidth="xs">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 'calc(100vh - 70px)', // Descontar la altura del header
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              borderRadius: '5px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
              backgroundColor: '#fff',
              width: '380px',
              height: 'auto',
              overflow: 'hidden' // Asegura que el contenido se mantenga dentro de los bordes redondeados
            }}
          >
            <Box
              sx={{
                // backgroundColor: '#f2f3f2',
                backgroundColor: '#f2f3f3',
                padding: '10px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '220px', // Altura fija para el contenedor de la imagen
                width: '100%', // Abarca todo el ancho disponible
              }}
            >
              <img 
                src="/cde_fullcolor.png" 
                alt="Logo" 
                style={{ maxWidth: '55%'}} // Tamaño ajustado de la imagen
              />
            </Box>
            <Box
              sx={{
                padding: '20px',
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{ fontFamily: 'Figtree', fontSize: '1.25rem', lineHeight: 1.2, fontWeight: 'bold' }}
                my={1.5}
              >
                FRIDAY
                <br />
                CDE MIPYME RL
              </Typography>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="correo"
                name="correo"
                label="Correo Electrónico"
                autoComplete="email"
                autoFocus
                value={credentials.correo}
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                name="password_hash"
                label="Contraseña"
                type="password"
                id="password_hash"
                autoComplete="current-password"
                value={credentials.password_hash}
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                }}
              />
              {error && <Alert severity="error">{error}</Alert>}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={handleSubmit}
                endIcon={loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : <LoginIcon />}
                disabled={loading}
                sx={{ mt: 3, mb: 2, backgroundColor: '#2782b2', '&:hover': { backgroundColor: '#2d95cc',color: 'white' } }}
              >
                {loading ? 'INGRESANDO...' : 'INGRESAR'}
              </Button>

              {showForceCleanCache && (
                <button type='button' style={{ marginTop: "30px" }} className="btn-next" onClick={clearCacheData}>
                  Actualizar a la Última Versión
                </button>
              )}

              {/* <Typography variant="body2" >
                ¿Olvido su Contraseña?
              </Typography> */}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Login;
